import { render } from "./ModalAlertPassword.vue?vue&type=template&id=9279dbb6"
import script from "./ModalAlertPassword.vue?vue&type=script&lang=js"
export * from "./ModalAlertPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__